module.exports = __webpack_public_path__ + "static/media/todos-scheduled.52252006.svg";